'use strict';

/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import ProjectTaxModalCreate from './controller/taxModalCreate';
import ProjectTaxTableDirective from './directive/projectTaxTable';

export default angular.module('investmentProject.project.tax', [])
    .controller('ProjectTaxModalCreateController', ProjectTaxModalCreate)
    .directive('projectTaxTable', ProjectTaxTableDirective)
    .name;
